import React from 'react';
import { Accordion } from '../ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito comprar suplementos caros?',
    answer: 'No, este método se basa en alimentos reales que puedes encontrar en cualquier supermercado y en rutinas de hábitos simples. No hay pastillas ni batidos mágicos.'
  }, {
    question: '¿Es difícil de seguir si tengo poco tiempo?',
    answer: 'Está diseñado específicamente para mujeres con vidas ocupadas. Las rutinas nocturnas duran menos de 15 minutos y las recetas son rápidas y prácticas.'
  }, {
    question: '¿Pasaré hambre con los micro-ayunos?',
    answer: 'Al contrario, aprenderás a comer para saciar a tus hormonas, no para pasar privaciones. Los micro-ayunos son suaves y se adaptan a tu ritmo natural.'
  }, {
    question: '¿Tengo acceso de por vida al material?',
    answer: 'Sí, una vez que adquieras el eBook y las guías, son tuyos para siempre. Podrás descargarlos y leerlos en cualquier dispositivo cuando quieras.'
  }];
  return <section className="py-20 bg-beige-light" data-id="element-118">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="text-center mb-12" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-121">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-taupe-light font-body" data-id="element-122">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <Accordion items={faqs} data-id="element-123" />
      </div>
    </section>;
}